exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-box {\n    padding: 15px;\n    background-color: #f7f7f9;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 22px;\n    cursor: pointer;\n    border: 0;\n}\n.list-box-border {\n\tborder: 1px solid rgba(0,0,0,.125);\n}\n.list-add-data {\n    clear: both;\n}\n.list-add-data input {\n    width: calc(100% - 110px);\n    height: 40px;\n    border: 1px solid #ddd;\n    display: inline-block;\n    vertical-align: middle;\n    padding: 5px 10px;\n}\n.list-checkbox .checkbox-fade input {\n    height: auto !important;\n}\n.list-checkbox label {\n    line-height: normal;\n    margin: 0;\n}\n.list-checkbox .checkbox-fade {\n    margin: 0 !important;\n    display: block;\n}\n.listing-leftbtn {\n    padding-top: 10px;\n}\n.mar-top15 {\n    margin-top: 15px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/image-slider/image-slider.component.css
// module id = ../../../../../src/app/event/image-slider/image-slider.component.css
// module chunks = main